/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import PropTypes from "prop-types";
import React from "react";
import ListComponent from "../../../../arrow-components/src/components/Rows/ListComponent";
import get from "lodash/get";
import "./search-page.m.css";

export const SearchPageResults = ({ collection, config, getMoreStories, limit, hideLoadmore, builderConfig }) => {
  const { "pagebuilder-config": pbconfig, "theme-attributes": themeAttributes } = config;
  const pbUpdatedConfig = builderConfig || pbconfig;
  const pbSearchConfig = get(pbUpdatedConfig, ["search", "pageSetting", "searchResultsConfig"], {});
  const sectionTagTemplate = get(
    pbUpdatedConfig,
    ["general", "rows", "sectionTag", "template"],
    get(pbSearchConfig, ["sectionTagTemplate"], "solid")
  );
  const footerButton = get(pbSearchConfig, ["footerButton"], "SubsequentLoadCount");
  const showRowTitle = false;
  const fallbackImageUrl = get(
    pbUpdatedConfig,
    ["general", "fallbackImage", "url"],
    get(themeAttributes, ["imageFallbackUrl"])
  );

  return (
    <ListComponent
      collection={collection}
      config={{
        ...pbSearchConfig,
        sectionTagTemplate,
        showRowTitle,
        footerButton,
        fallbackImageUrl
      }}
      getMoreStories={getMoreStories}
      hideButton={hideLoadmore}
      limit={limit}
    />
  );
};

SearchPageResults.propTypes = {
  collection: PropTypes.any,
  config: PropTypes.shape({
    collectionNameBorderColor: PropTypes.string,
    borderColor: PropTypes.string,
    theme: PropTypes.string,
    border: PropTypes.string,
    collectionNameTemplate: PropTypes.string,
    footerButton: PropTypes.string,
    initialLoadCount: PropTypes.string,
    getLoadMore: PropTypes.func,
    "pagebuilder-config": PropTypes.object,
    "theme-attributes": PropTypes.object
  })
};
